import React from 'react'
import {DELIVERY_VALUES_ENUM} from '@page-components/Checkout/Checkout/Delivery/Duration/Update/TimeField/useTimeField'

export const CheckoutContext = React.createContext({
  deliveryType: DELIVERY_VALUES_ENUM.deliver_now,
  setDeliveryType: (deliveryType: number) => {
    /* This is intentional */
  },
  timeOptions: null,
  setTimeOptions: (options: any[]) => {
    /* This is intentional */
  }
})
CheckoutContext.displayName = 'CheckoutContext'
